import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Body, Caption, Eyebrow, Reveal, Title } from '../components/deck/Type';
import { productShots } from '../data/ecosystem';
const flow = ['Canadian startups apply', 'DiligenceGPT™ structures the opportunity', 'Sony Innovation Fund independently evaluates'];
const outcomes = ['Broader Canadian coverage', 'Structured company intake', 'Consistent evaluation', 'Visibility into startup activity', 'Dedicated market infrastructure'];
export function SonyCaseStudySlide() {
  return <Slide index={7} data-id="element-253" data-mp="34ssfsg2h1hcu">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-254" data-mp="2qvdi6o22e39s">
        <div className="max-w-[64%]" data-id="element-255" data-mp="2qx6sqefst7n2">
          <Eyebrow data-id="element-256" data-mp="2uw5slkmoae7n">Enterprise engagement</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-257" data-mp="2uwz5728bbxxp">
            Sony Innovation Fund is using StartupFuel to expand its venture
            coverage in Canada.
          </Title>
        </div>
        <div className="text-right" data-id="element-258" data-mp="t417arzoif5w">
          <p className="text-[clamp(20px,2.4vw,50px)] leading-none text-[#2FBE8F]" style={{
          fontFamily: 'var(--font-serif)'
        }} data-id="element-259" data-mp="t2zv2k6xfmml">
            $100K
          </p>
          <p className="mt-[1vh] text-[clamp(7.5px,0.78vw,16px)] uppercase tracking-[0.2em] text-[#7C8699]" data-id="element-260" data-mp="1mx14ppnzaxlb">
            Paid 12-month engagement
          </p>
        </div>
      </div>

      <div className="mt-[3vh] grid min-h-0 flex-1 grid-cols-[56%_1fr] gap-[2.6vw]" data-id="element-261" data-mp="1wpp14jb1qzji">
        <Reveal delay={0.1} className="flex min-h-0 flex-col" data-id="element-262" data-mp="18zuqm8e79n2f">
          <span className="text-[clamp(8px,0.82vw,17px)] tracking-[0.16em] text-[#3B8CFF]" data-id="element-263" data-mp="140riug6u52qr">
            app.dgpt.io/p/sonyvc
          </span>
          <img src={productShots.pipelineTable} alt="DiligenceGPT dedicated portal pipeline view listing incoming startup opportunities with fit scores and status" className="mt-[1.4vh] min-h-0 w-full border border-white/12 object-contain object-top" data-id="element-264" data-mp="1iytqb1gzm8da" />
        </Reveal>

        <div className="flex min-h-0 flex-col" data-id="element-265" data-mp="2pfoy7vzb38bt">
          <Body data-id="element-266" data-mp="2whkcukx0sgt2">
            Sony Innovation Fund is working with StartupFuel and DiligenceGPT™ to
            expand its coverage of the Canadian innovation ecosystem and create a
            more structured process for discovering and evaluating startup
            opportunities.
          </Body>

          <div className="mt-auto space-y-[1.6vh]" data-id="element-267" data-mp="3bebdexifjyk9">
            {flow.map((step, i) => <Reveal key={step} delay={0.14 + i * 0.08} className="flex items-baseline gap-[0.9vw] border-t border-white/10 pt-[1.4vh]" data-id="element-268" data-mp="2dr2ostn4u9e1" data-mpi={i}>
                <span className="text-[clamp(8px,0.8vw,17px)] tracking-[0.2em] text-white/30" data-id="element-269" data-mp="2no7aytgza4uu">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="text-[clamp(10px,1.08vw,23px)] leading-snug text-[#DCE3EE]" data-id="element-270" data-mp="1uztckclz96ir">
                  {step}
                </span>
              </Reveal>)}
          </div>
        </div>
      </div>

      <Reveal delay={0.4} className="mt-[2.4vh] grid grid-cols-5 border-t border-white/12 pt-[1.8vh]" data-id="element-271" data-mp="h4a5hqfr15jf">
        {outcomes.map((o, i) => <Caption key={o} className={i === 0 ? 'pr-[1vw]' : 'border-l border-white/10 pl-[1vw] pr-[1vw]'} data-id="element-272" data-mp="d02ipysupznu" data-mpi={i}>
            {o}
          </Caption>)}
      </Reveal>
    </Slide>;
}